export const LINE_ITEMS_ERROR_KEYS = {
  notAllowed: 'errors:lineItems.notAllowed',
  conflict: 'errors:lineItems.conflict',
  notParticipant: 'errors:lineItems.notParticipant',
  remindTooSoon: 'errors:lineItems.remindTooSoon',
} as const;

export type LineItemsErrorKey =
  (typeof LINE_ITEMS_ERROR_KEYS)[keyof typeof LINE_ITEMS_ERROR_KEYS];

export interface LineItemsErrorDetails {
  expenseId?: string;
}

export const LINE_ITEM_LIMITS = {
  MAX_ITEMS: 100,
  NAME_MAX: 80,
  QUANTITY_MIN: 1,
  QUANTITY_MAX: 999,
  /** UTF-8 bytes (Buffer.byteLength / TextEncoder), not string length. */
  MAX_SERIALIZED_BYTES: 64 * 1024,
  MAX_PARTICIPANTS: 100,
} as const;
